import { render, staticRenderFns } from "./overdue-invoices.vue?vue&type=template&id=6a22778c&scoped=true&"
import script from "./overdue-invoices.vue?vue&type=script&lang=ts&"
export * from "./overdue-invoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22778c",
  null
  
)

export default component.exports